/**
 * Tap-to-pay setup guidance. A PWA cannot push-provision cards into Apple
 * Pay / Google Wallet, but both accept MANUAL card entry — and the PSE
 * integration (CardDetails) shows the full card inside Florin. So the user
 * types the number into their phone's wallet app once and never hears the
 * words "crypto wallet".
 */

const IS_IOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

const WALLET_NAME = IS_IOS ? "Apple Pay" : "Google Wallet";

export function TapToPay({ compact = false }: { compact?: boolean }) {
  return (
    <div className="card">
      <div className="balance-label" style={{ marginBottom: 8 }}>
        📲 Tap-to-pay in shops
      </div>
      {!compact && (
        <p className="sub" style={{ marginBottom: 10 }}>
          Add your card to {WALLET_NAME} once and every contactless terminal takes it — your
          round-ups work exactly the same.
        </p>
      )}
      <ol style={{ fontSize: 14, paddingLeft: 20, lineHeight: 1.9 }}>
        <li>
          Tap <strong>Reveal card details</strong> {compact ? "in Settings → Card" : "above"}.
        </li>
        {IS_IOS ? (
          <li>
            Open <strong>Wallet</strong> → <strong>+</strong> → Debit or Credit Card →{" "}
            <strong>Enter Card Details Manually</strong>.
          </li>
        ) : (
          <li>
            Open <strong>Google Wallet</strong> → <strong>Add to Wallet</strong> → Payment card →{" "}
            <strong>New credit or debit card</strong>.
          </li>
        )}
        <li>Type in the card number and expiry — a text to your verified phone confirms it.</li>
        <li>Done — pay by tapping your phone.</li>
      </ol>
    </div>
  );
}
